module.exports = __webpack_public_path__ + "static/media/chateau-baie-comeau.ca77a35b.png";